export default {
  groupProject: 'Projects',
  groupAdmin: 'Administration',
  groupSuperAdmin: 'Super Admin',
  photoLive: 'Photo Live',
  conference: 'Events',
  eventManage: 'Events',
  registrationManage: 'Registrations',
  hotelManage: 'Hotels',
  accountManage: 'Accounts',
  roleManage: 'Roles',
  permissionManage: 'Permissions',
  companyManage: 'Companies'
}
